import React from "react";
import { T } from "../app/tokens.js";
import { coverageText } from "../services/seatAccounting.js";

export function PartialMarker({ coverage, measure }) {
  const text = coverageText(coverage, measure);
  return text ? <small tabIndex={0} title={text} aria-label={text}
    style={{ color: T.ragAmberText, fontSize: T.fsXxs, fontWeight: T.fwSemibold }}> partial</small> : null;
}
